import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { StatusBar } from "react-native";
import { fetchApi } from "../api";
import Loading from "../components/Loading";
import Errors from "../components/Errors";
import { setFavItems } from "../actions/fav";
import { setCartItems } from "../actions/cart";
import { setItemTypes } from "../actions/items";
import { setFilterOptions } from "../actions/filter";
import Drawer from "./Drawer";
import { setUserData } from "../actions/user";

function SecuredScreens({
  setFavItems,
  setCartItems,
  setItemTypes,
  setFilterOptions,
  setUserData,
  loginData = {},
}) {
  const [isReady, setIsReady] = useState(false);
  const [error, setError] = useState(null);

  const fetchInitialData = () => {
    let initialFetchApis = ["/items/types", "/items/filters"];
    if (!loginData.is_guest) {
      initialFetchApis = [...initialFetchApis, "/favitems", "/cart"];
    }
    let promises = initialFetchApis.map((path) =>
      fetchApi({
        path: path,
      }).then((res) => {
        if (res.results) {
          return res.results;
        }
        throw res;
      })
    );

    Promise.all(promises)
      .then(async (data) => {
        setItemTypes(data[0]);
        setFilterOptions(data[1]);
        await fetchApi({
          path: "/users/me",
        }).then((res) => {
          if (res.error) {
            throw res.error;
          }
          setUserData(res);
        });
        if (!loginData.is_guest) {
          setFavItems(data[2]);
          setCartItems(data[3]);
        }
        setIsReady(true);
      })
      .catch((e) => {
        console.log(e);
        setError(e.error);
      });
  };

  useEffect(() => {
    StatusBar.setBarStyle("dark-content");
    fetchInitialData();
  }, [loginData]);

  return (
    <>
      {!error ? (
        isReady ? (
          <Drawer />
        ) : (
          <Loading />
        )
      ) : (
        <Errors
          error={error}
          onPress={() => {
            setError(null);
            fetchInitialData();
          }}
        />
      )}
    </>
  );
}

const mapStateToProps = (state) => ({
  loginData: state.user.loginData,
});

const mapDispatchToProps = (dispatch) => ({
  setFavItems: (data) => dispatch(setFavItems(data)),
  setCartItems: (data) => dispatch(setCartItems(data)),
  setItemTypes: (data) => dispatch(setItemTypes(data)),
  setFilterOptions: (data) => dispatch(setFilterOptions(data)),
  setUserData: (data) => dispatch(setUserData(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SecuredScreens);
